<div class="requests-container">
  <h3>Sorğularım</h3>
  <div class="tabs">
    <button [class.active]="activeTab === 'Aktiv'" (click)="activeTab = 'Aktiv'">Aktiv</button>
    <button [class.active]="activeTab === 'Gözləyir'" (click)="activeTab = 'Gözləyir'">Gözləyir</button>
    <button [class.active]="activeTab === 'Rədd edilmiş'" (click)="activeTab = 'Rədd edilmiş'">Rədd edilmiş</button>
    <button [class.active]="activeTab === 'Dayandırılmış'" (click)="activeTab = 'Dayandırılmış'">Dayandırılmış</button>
    <button [class.active]="activeTab === 'Vaxtı bitmiş'" (click)="activeTab = 'Vaxtı bitmiş'">Vaxtı bitmiş</button>
  </div>

  <div class="table-wrapper" *ngIf="requests.length > 0; else emptyState">
    <table class="table">
      <thead>
        <tr>
          <th>Sorğu adı</th>
          <th>Kriteriyalar</th>
          <th>Tarix</th>
          <th>Status</th>
          <th>Əməliyyatlar</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let req of requests">
          <td>{{req.name}}</td>
          <td>{{req.criteria}}</td>
          <td>{{req.date}}</td>
          <td><span class="badge" [ngClass]="req.status.toLowerCase()">{{req.status}}</span></td>
          <td class="actions">
            <button class="btn-icon">👁</button>
            <button class="btn-icon">✏️</button>
            <button class="btn-icon">🗑️</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <p>Nəticə tapılmadı</p>
      <button class="btn-primary">Yeni sorğu yarat</button>
    </div>
  </ng-template>
</div>
